import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LayoutGrid = createReactComponent("LayoutGrid", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "7",
  key: "ikfx8m"
}], ["rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "7",
  key: "1dv5ta"
}], ["rect", {
  x: "14",
  y: "14",
  width: "7",
  height: "7",
  key: "lpkkw6"
}], ["rect", {
  x: "3",
  y: "14",
  width: "7",
  height: "7",
  key: "aud0k0"
}]]]);
export default LayoutGrid;